module.exports = __webpack_public_path__ + "static/media/Niti Oza.0b594124.png";